/**
 * @summary Instantiates SVG4Everybody polyfill conditionally.
 */

const newerIEUA = /\bTrident\/[567]\b|\bMSIE (?:9|10)\.0\b/;
const webkitUA = /\bAppleWebKit\/(\d+)\b/;
const olderEdgeUA = /\bEdge\/12\.(\d+)\b/;
const edgeUA = /\bEdge\/.(\d+)\b/;

/*
 * Conditionally loads pollyfill, based on conditional taken from the polyfill
 * source code.
 */
if ( newerIEUA.test( navigator.userAgent ) ||
		( navigator.userAgent.match( olderEdgeUA ) || [])[1] < 10547 ||
		( navigator.userAgent.match( webkitUA ) || [])[1] < 537 ||
		edgeUA.test( navigator.userAgent ) && window.top !== window.self ) {
	import( /* webpackChunkName: "svg4everybody" */ 'svg4everybody' )
		.then( init => init({ polyfill: true }) );
}



// WEBPACK FOOTER //
// ./src/js/svg-polyfill.js